import React from 'react';
import { CMSSubscription } from '../../../types/CMSTypes';
import { epochToDateStringWithYear } from '../../../helper';

import './CMSSubscriptions.css';
import { usePagination } from '../../../hooks/usePagination';

type Props = {
  allActiveSubscriptions: {
    subscriptions: CMSSubscription[];
    pagination: { hasMore: boolean };
  } | null;
  getAllSubscriptionsFromServer: Function;
};

const CMSSubscriptions: React.FC<Props> = ({
  allActiveSubscriptions,
  getAllSubscriptionsFromServer,
}) => {
  usePagination(
    !!allActiveSubscriptions?.pagination?.hasMore,
    getAllSubscriptionsFromServer
  );

  return (
    <div className='cmsSubscription-main'>
      <div className='header-container'>
        <div style={{ fontSize: 24, fontWeight: 700, color: '#161616' }}>
          Subscription
        </div>
      </div>

      <div className='top-row-subscription'>
        <span className='delivery-info'>Delivery Information</span>
        <div className='header-right'>
          <span className='search-container'>
            <button className='search-button'>
              <img
                src='./assets/searchcms.svg'
                alt='Search'
                className='search-icon'
              />
              <input
                type='text'
                placeholder='Search'
                className='search-input'
                style={{
                  backgroundColor: 'white',
                  border: 'none',
                  borderRadius: 'none',
                  display: 'flex',
                }}
              />
            </button>
          </span>
        </div>
      </div>
      <div>
        <table className='report-table-cmssubscription'>
          <thead>
            <tr className='report-table-heading'>
              <th>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  Subscription Name
                  <img
                    src='./assets/arrowdown.svg'
                    alt='arrowDown'
                    style={{
                      marginLeft: 5,
                    }}
                  />
                </div>
              </th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Price(€)</th>
              <th>Plan Type</th>
              <th>Plan Status</th>
              <th>Max Users</th>
              <th>User Type</th>
            </tr>
          </thead>
          <tbody className='report-table-body'>
            {(allActiveSubscriptions?.subscriptions ?? []).map((row, index) => (
              <tr key={index}>
                <td>{row.user_id}</td>
                <td
                  style={{
                    color: '#667085',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  {epochToDateStringWithYear(
                    row.plan.updateDate._seconds,
                    'short'
                  )}
                </td>
                <td
                  style={{
                    color: '#667085',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  {epochToDateStringWithYear(
                    row.plan.endDate._seconds,
                    'short'
                  )}
                </td>
                <td
                  style={{
                    color: '#667085',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  €{row.plan.price || 0}
                </td>
                <td
                  style={{
                    color: '#667085',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  {row.plan.type?.toUpperCase()}
                </td>
                <td
                  style={{
                    color: '#667085',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  {row.plan.status?.toUpperCase()}
                </td>
                <td
                  style={{
                    color: '#667085',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  {row.plan.price}
                </td>
                <td
                  style={{
                    color: '#667085',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  {row.user.userType?.toUpperCase()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CMSSubscriptions;
